import { render, staticRenderFns } from "./anchorRoomPK.vue?vue&type=template&id=561b33f3&scoped=true&lang=pug"
import script from "./anchorRoomPK.vue?vue&type=script&lang=js"
export * from "./anchorRoomPK.vue?vue&type=script&lang=js"
import style0 from "./anchorRoomPK.vue?vue&type=style&index=0&id=561b33f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b33f3",
  null
  
)

export default component.exports